import { combineReducers } from 'redux';
import {
  PROCESSING,
  DONE,
  ERROR,
  ADD_NOTIFICATION,
  CHANGE_CUSTOMER,
  CHANGE_LANG,
  GET_CUSTOMERS_PROCESSING,
  GET_CUSTOMERS_SUCCESS,
  GET_CUSTOMERS_FAILURE,
  OFFER_APPROVEMENT_CHANGED,
  REMOVE_NOTIFICATION,
  UPDATE_TOKEN,
  OPEN_MODAL,
  CLOSE_MODAL,
  SET_CONTACTS_COUNT,
  LOCAL_STORAGE_CLIENT_BIN
} from '../config/constants';
import { getValueFromStorage, hasInStorage } from '../Utils';

export const lang = (state = 'ru', action) => {
  if (action.type === CHANGE_LANG) {
    return action.lang;
  }
  return state;
};

export const token = (state = null, action) => {
  switch (action.type) {
    case UPDATE_TOKEN:
      return action.token;
    default:
      return state;
  }
};

export const userInfo = (state = {}, action) => {
  switch (action.type) {
    case GET_CUSTOMERS_PROCESSING:
      return { status: PROCESSING };
    case GET_CUSTOMERS_SUCCESS:
      return {
        ...state,
        status: DONE,
        ...action.data,
      };
    case GET_CUSTOMERS_FAILURE:
      return {
        ...state,
        status: ERROR,
      };
    case OFFER_APPROVEMENT_CHANGED:
      const newState = { ...state };
      if (newState.customers) {
        newState.customers.forEach((customer) => {
          if (customer.idDocNum === action.idDocNum && customer.services && customer.services.b2b_selfcare) {
            customer.services.b2b_selfcare.isOfferApproved = action.isOfferApproved;
          }
        });
      }
      return newState;
    default:
      return state;
  }
};

export const customer = (state = {}, action) => {
  switch (action.type) {
    case GET_CUSTOMERS_SUCCESS:
      let activeCustomer;
      if (hasInStorage(LOCAL_STORAGE_CLIENT_BIN)) {
        activeCustomer = action?.data?.customers?.filter(({ idDocNum }) => {
          return idDocNum === getValueFromStorage(LOCAL_STORAGE_CLIENT_BIN);
        })[0] || action?.data?.customers?.[0];
      } else {
        activeCustomer = action?.data?.customers?.[0];
      }
      return activeCustomer;
    case CHANGE_CUSTOMER:
      return action.customer;
    case OFFER_APPROVEMENT_CHANGED:
      if (state.idDocNum !== action.idDocNum) {
        return state;
      }
      const newState = { ...state };
      if (newState.services && newState.services.b2b_selfcare) {
        newState.services.b2b_selfcare.isOfferApproved = action.isOfferApproved;
      }
      return newState;
    default:
      return state;
  }
};

export const notifications = (state = {}, action) => {
  switch (action.type) {
    case ADD_NOTIFICATION:
      return {
        ...state,
        [new Date().getTime()]: {
          message: action.message,
          error: action.error,
        },
      };
    case REMOVE_NOTIFICATION:
      return Object.keys(state)
        .filter(key => key !== action.id)
        .reduce((obj, key) => ({ ...obj, [key]: state[key] }), {});
    default:
      return state;
  }
};

export const modal = (state = null, action) => {
  switch (action.type) {
    case OPEN_MODAL:
      return {
        name: action.name,
        isOpened: true,
      };
    case CLOSE_MODAL:
      return { ...state, isOpened: false };
    default:
      return state;
  }
};

const getNewState = (state, action) => {
  if (action.type === 'CLEAR') {
    return {
      ...state,
      lang: state.lang
    };
  }
  return state;
};

export const contactsCount = (state = null, action) => {
  switch (action.type) {
    case SET_CONTACTS_COUNT:
      return action.contactsCount;
    default:
      return state;
  }
};

export default (state, action) => combineReducers({
  lang,
  token,
  userInfo,
  customer,
  notifications,
  modal,
  contactsCount
})(getNewState(state, action), action);
